import React from "react";

import Standard from "./Standard";
import Professional from "./Professional";
import { PlanContainer } from "./index.styles";
import { Isubscription } from "./interface";

interface Iprops {
  subscriptions: Isubscription[];
  onClick: () => {};
}

const Plan = ({ subscriptions, onClick }: Iprops) => {
  const standardSub =
    subscriptions && subscriptions.find((sub) => sub.name === "Standard Plan");
  const professionalSub =
    subscriptions &&
    subscriptions.find((sub) => sub.name === "Professional Plan");
  return (
    <PlanContainer id="plans">
      <h2> Choose a plan that fits your needs </h2>
      <p>
        If you're just looking to make a few hires, or you're always looking for
        talent.
        <p> We've got you covered! </p>
      </p>
      <Standard onClick={onClick} subscription={standardSub} />
      <Professional onClick={onClick} subscription={professionalSub} />
    </PlanContainer>
  );
};

export default Plan;
